import React from "react";
import { Field, change } from "redux-form";
import { get } from "lodash";
import { Row, Col, Collapse } from "react-bootstrap";
import { update } from "MODULES/RMAsAndWarranties/actions";
import {
  Form as AppForm,
  Check,
  CheckGroup,
  CurrencyField,
  Select,
  form
} from "MODULES/shared/components/Forms";
import {
  CHARGE_NO_FAULT_FOUND_FEE,
  NO_FAULT_FOUND_FEE,
  NO_FAULT_FOUND_FEE_INVOICED
} from "MODULES/RMAsAndWarranties/constants";
import { properCase } from "LIB/formatters/text";
import { connect } from "react-redux";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import { DEFAULT_NO_FAULT_FOUND_FEE } from "APP_ROOT/constants";

const restockingFeeOptions = [
  { value: false, text: "No" },
  { value: true, text: "Yes" }
];

export function Form(props) {
  const defaultNoFaultFoundFee = get(useSettings(), DEFAULT_NO_FAULT_FOUND_FEE);
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row className="row-col-gutters-half">
          <Col md={6}>
            <CheckGroup justified title="Stock Part?">
              <Field name="stock_part" component={Check} label="Yes" />
            </CheckGroup>
          </Col>
          <Col md={6}>
            <Field
              component={Select}
              options={restockingFeeOptions}
              name="charge_restocking_fee"
              label="Charge Restocking Fee?"
              prompt={false}
              onChange={e => e.currentTarget.blur()} // Web browser likes to hold on to focus on select. Force browser to requlinquish focus and return it to the form.
            />
          </Col>
        </Row>
        <Field
          name="charge_restocking_fee"
          component={({ input }) => (
            <Collapse in={!!input.value}>
              <Row className="row-col-gutters-half">
                <Col md={6}>
                  <CurrencyField name="restocking_fee" label="Restocking Fee" />
                </Col>
                <Col md={6}>
                  <CheckGroup justified title="Invoice Restocking Fee?">
                    <Field
                      name="restocking_fee_issued"
                      component={Check}
                      label="Yes"
                    />
                  </CheckGroup>
                </Col>
              </Row>
            </Collapse>
          )}
        />
        <Row>
          <Col md={6}>
            <CheckGroup justified title="Charge Customer No Fault Found Fee">
              <Field
                name={CHARGE_NO_FAULT_FOUND_FEE}
                component={Check}
                label="Yes"
                onChange={val => {
                  if (val) {
                    props.setFieldValue(NO_FAULT_FOUND_FEE)(
                      defaultNoFaultFoundFee
                    );
                  } else {
                    props.setFieldValue(NO_FAULT_FOUND_FEE)(null);
                  }
                }}
              />
            </CheckGroup>
          </Col>
        </Row>
        <Field
          name={CHARGE_NO_FAULT_FOUND_FEE}
          component={({ input }) => (
            <Collapse in={!!input.value}>
              <Row className="row-col-gutters-half">
                <Col md={6}>
                  <CurrencyField
                    name={NO_FAULT_FOUND_FEE}
                    label={properCase(NO_FAULT_FOUND_FEE)}
                  />
                </Col>
                <Col md={6}>
                  <CheckGroup
                    justified
                    title="No Fault Found Fee has been invoiced?"
                  >
                    <Field
                      name={NO_FAULT_FOUND_FEE_INVOICED}
                      component={Check}
                      label="Yes"
                    />
                  </CheckGroup>
                </Col>
              </Row>
            </Collapse>
          )}
        />
      </AppForm.Body>
    </AppForm>
  );
}

const formName = "rmaRestocking";
export default connect(undefined, dispatch => ({
  onSubmit: values => dispatch(update(values)),
  setFieldValue: field => val => dispatch(change(formName, field, val))
}))(
  form({
    form: formName
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/Restocking/Form.jsx